import { Box, Typography, styled } from '@mui/material';
import { getThemeColors } from '../../helpers/themeStyles';
import { THEME_MODES } from '../../theme';

export {
  TabSwitchWrapper as SegmentedControlWrapper,
  TabSwitchContainer as SegmentedControl,
  TabSwitchItem as SegmentedOption,
} from '../../components/FilterToolbarStyles';

export const ContentGrid = styled(Box)({
  display: 'flex',
  padding: '24px 0',
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
});

export const FormSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  flex: 1,
  paddingLeft: 24,
  minHeight: 0,
  overflow: 'auto',
  paddingRight: 24,
});

export const FormRow = styled(Box)({
  display: 'flex',
  gap: 20,
  '& > *': { flex: 1 },
});

export const LabelRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const ActivityToggle = styled(Box)(({ theme }) => {
  const colors = getThemeColors(theme);
  const isDarkMode = theme.palette.mode === THEME_MODES.DARK;

  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
    borderRadius: 20,
    backgroundColor: isDarkMode ? colors.surfaceElevated : colors.surfaceSecondary,
    border: `1px solid ${colors.borderSubtle}`,
    color: colors.textPrimary,
    '& .MuiSwitch-root': {
      width: 74,
      height: 30,
      padding: 0,
    },
    '& .MuiSwitch-switchBase': {
      padding: 0,
      transform: 'translateX(2px) translateY(2px)',
      '&.Mui-checked': {
        transform: 'translateX(32px) translateY(2px)',
        '& + .MuiSwitch-track': {
          backgroundColor: colors.accent,
          opacity: 1,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      width: 40,
      height: 26,
      padding: 0,
      borderRadius: 18,
      backgroundColor: isDarkMode ? '#1A1A1A' : colors.textPrimary,
      boxShadow: 'none',
    },
    '& .MuiSwitch-track': {
      borderRadius: 20,
      backgroundColor: isDarkMode ? '#494949' : colors.borderSubtle,
      opacity: 1,
    },
  };
});

export const AppsSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
});

export const AppsRow = styled(Box)({
  display: 'flex',
  gap: 12,
  flexWrap: 'wrap',
});

export const DocumentsSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 2,
  minHeight: 0,
  overflow: 'auto',
  paddingRight: 24,
  paddingLeft: 24,
});

export const SectionTitle = styled(Typography)({
  fontSize: 16,
  fontWeight: 500,
  textTransform: 'uppercase',
  letterSpacing: 0.06,
  marginBottom: 24,
});

export const DocumentsGrid = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 24,
});

export const ActionIconButton = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$accentColor',
})(({ theme, $accentColor }) => {
  const colors = getThemeColors(theme);

  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: 0,
    borderRadius: 4,
    color: colors.textMuted,
    '&:hover': {
      ...($accentColor && { color: $accentColor }),
    },
  };
});

export const DocumentCard = styled(Box)(({ theme }) => {
  const colors = getThemeColors(theme);
  const isDarkMode = theme.palette.mode === THEME_MODES.DARK;

  return {
    borderRadius: 20,
    height: 160,
    backgroundColor: isDarkMode ? colors.surfaceElevated : colors.surfaceSecondary,
    border: `1px solid ${colors.borderSubtle}`,
    color: colors.textPrimary,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
  };
});

export const DocumentCardWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  width: 241,
});

export const DocumentCardActions = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const DocumentCardLabel = styled(Typography)({
  fontSize: 14,
  fontWeight: 700,
});

export const DocumentCardDateLabel = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 500,
  color: getThemeColors(theme).textMuted,
  marginTop: 4,
}));

export const SegmentedFieldLabel = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 500,
  color: getThemeColors(theme).textCaption,
  marginBottom: 12,
}));
